import { Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { growthbook, setGrowthBookAttributes, GrowthBookAttributes } from "../growthbook";
import { UserService } from "../../core/user/user.service";
import { User } from "../../core/user/user.model";

@Injectable({
    providedIn: "root",
})
export class GrowthBookService implements OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(private userService: UserService) {}

    /**
     * Verifica se uma feature flag está ativa
     * @param flagName - Nome da feature flag
     * @returns boolean - true se a flag estiver ativa, false caso contrário
     */
    isFeatureEnabled(flagName: string): boolean {
        return growthbook.isOn(flagName);
    }

    /**
     * Obtém o valor de uma feature flag
     * @param flagName - Nome da feature flag
     * @returns Valor da feature flag ou null
     */
    getFeatureValue<T = unknown>(flagName: string): T | null {
        return (growthbook.getFeatureValue(flagName, null) as T) || null;
    }

    /**
     * Define os atributos do GrowthBook baseado no usuário atual
     */
    setUserAttributes(): void {
        const user: User = this.userService.user$;

        if (user && user.user && user.user.email && user.minibanco) {
            const userIdFromToken = user.user.id?.toString() || "";
            const companyIdFromToken = user.minibanco.id?.toString() || "";

            const attributes: GrowthBookAttributes = {
                id: userIdFromToken,
                companyId: companyIdFromToken,
                minibankId: user.minibanco.id?.toString() || "",
                email: user.user.email,
            };

            setGrowthBookAttributes(attributes);
        }
    }

    /**
     * Define atributos customizados do GrowthBook
     * @param attributes - Atributos a serem definidos
     */
    setAttributes(attributes: GrowthBookAttributes): void {
        setGrowthBookAttributes(attributes);
    }

    /**
     * Recarrega as features do GrowthBook
     */
    async reloadFeatures(): Promise<boolean> {
        try {
            await growthbook.loadFeatures();
            return true;
        } catch (error) {
            console.error("Erro ao recarregar features do GrowthBook:", error);
            return false;
        }
    }

    /**
     * Obtém a instância do GrowthBook (para casos avançados)
     */
    getInstance(): typeof growthbook {
        return growthbook;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
